import AppMap from './AppMap';

export default AppMap;
